/** @deprecated  - import checkbox directly from input folder */
export { Checkbox, Checkbox as default } from "../../inputs/Checkbox";
